import React from 'react'

export default function Loading() {
  return (
    <div className='col-12' style={{padding:"60px"}}>
        <span class="fa fa-spinner fa-5x fa-pulse"></span>
    </div>
  )
}

 
